import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';
import { TokenStorageService } from './token-storage.service';
const AUTH_API = environment.apiUrl + 'auth/';
const OPENCART_API = environment.openCartApiUrl;

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private userId: string; // Add this property
  private httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
  };
  readonly resetpassurl = AUTH_API + "reset-pass";
  readonly sendemailUrl = AUTH_API + "/utility/sendEmail";
  readonly requestpassurl = AUTH_API + "request-pass";
  constructor(private http: HttpClient) {
  }
  login(email: string, password: string, type: string, rememberMe: boolean): Observable<any> {
    return this.http.post(AUTH_API + 'login', {
      email,
      password,
      type
    }).pipe(
      tap((response: any) => {
        if (response && response.userdata && response.userdata.id) { // Use 'id' property from userdata
          this.setUserId(response.userdata.id);

        }
        if (rememberMe === true) {
          localStorage.setItem('rememberMe', JSON.stringify(rememberMe));
        }
      })
    );
  }

  openCartLoginApi() {
    const query = `route=api/login`;
    const formData = new FormData();
    formData.append('Username', environment.openCartUserName);
    formData.append('key', environment.openCartApiKey);
    return this.http.post(OPENCART_API + '?' + query, formData);
  }

  register(username: string, email: string, password: string): Observable<any> {
    return this.http.post(AUTH_API + 'sign-up', {
      username,
      email,
      password
    }).pipe(
      tap((response: any) => {
        if (response && response.userdata && response.userdata.id) { // Use 'id' property from userdata
          this.setUserId(response.userdata.id);
        }
      })
    );
  }

  /*login(email: string, password: string, type: string): Observable<any> {
    return this.http.post(AUTH_API + 'login', {
      email,
      password,
      type
    });
  }*/
  loginclient(email: string, password: string, type: string): Observable<any> {
    return this.http.post(AUTH_API + 'login', {
      email,
      password,
      type
    });
  }

  /*
    register(username: string, email: string, password: string): Observable<any> {
      return this.http.post(AUTH_API + 'sign-up', {
        username,
        email,
        password
      });
    }*/

  signUp(userData): Observable<any> {
    return this.http.post(AUTH_API + 'sign-up', userData);
  }
  playerSignup(userData): Observable<any> {
    return this.http.post(AUTH_API + 'v2/player-register', userData);
  }
  updateUser(id, userData): Observable<any> {
    return this.http.put(AUTH_API + 'player-register/' + id, userData);
  }
  generateMobileOtp(mobileNumber): Observable<any> {
    return this.http.post(AUTH_API + 'mobile-otp', {
      mobileNumber
    });
  }
  otpLogin(otpData): Observable<any> {
    return this.http.post(AUTH_API + 'otp-login', otpData);
  }

  verifyOtp(otpData): Observable<any> {
    return this.http.post(AUTH_API + 'verify-otp', otpData);
  }

  sendEmail(request: any) {
    // console.log(request);
    return this.http.post<any>(this.sendemailUrl, request, this.httpOptions);

  }

  resetPassword(request: any) {
    return this.http.post(this.resetpassurl, request);
  }

  requestPassword(request: any) {
    return this.http.post(this.requestpassurl, request);
  }

  setUserId(userId: string) {
    this.userId = userId;
    //console.log("setuserId",this.userId);
  }
  getUserId(): string {
    return this.userId;
    // console.log("getuserId",this.userId);
  }
}
